import * as React from 'react';
import EventList from './../Components/EventList'
import SeriesPointsTable from './../Components/SeriesPointsTable'
import ClassSelector from './../Components/ClassSelector'
import DivisionSelector from './../Components/DivisionSelector'
import { withRouter } from './../Components/withRouter';

class SeriesPage extends React.Component<any, any> {

	constructor(props: any) {
	
		super(props);
	}

	state = {
		classId: '',
		divisionId: ''
	};

	changeClass = (classId) => {
		this.setState({ classId: classId });
	}
	
	changeDivision = (divisionId) => {
		this.setState({ divisionId: divisionId, classId: '' });
	}

	render() {		
		return (
			<div>
				<div>
					<h2>Series</h2>
					<EventList seriesId={this.props.match.params.seriesid} />
				</div>

				<div>
					<h2>Results</h2>

					{/*
					<div className="mb-3">
						<label className="form-label"><strong>Filter by Division:</strong></label>

						<div>
							<DivisionSelector 
								seriesId={this.props.match.params.seriesid} 
								onChange={this.changeDivision} 
								showAllButton={true}
								/>
						</div>
					</div>
					*/ }

					<div className="mb-3">
						<label className="form-label"><strong>Filter by Class:</strong></label>
						<div>
							<ClassSelector 
								seriesId={this.props.match.params.seriesid} 
								divisionId={this.state.divisionId}
								onChange={this.changeClass} 
								showAllButton={true}
								/>
						</div>
					</div>

					<SeriesPointsTable 
						seriesId={this.props.match.params.seriesid} 
						classId={this.state.classId} 
					/>
				</div>
			</div>
		)
	}
}

export default withRouter(SeriesPage);
